// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--3Pyz6","active":"Layout-module--active--hg8fz","layout__body":"Layout-module--layout__body--2DC6G"};